import React from "react";

export interface StepItem {
  id: string;
  label: string;
}

interface StepperProps {
  steps: StepItem[];
  current: string;
  completed: string[];
}

const Stepper = ({ steps, current, completed }: StepperProps) => (
  <ol className="op-stepper" aria-label="Configuration progress">
    {steps.map((step, index) => {
      const isCurrent = step.id === current;
      const isDone = completed.includes(step.id);
      return (
        <li
          key={step.id}
          className={`op-stepper__item${isCurrent ? " op-stepper__item--current" : ""}${
            isDone ? " op-stepper__item--done" : ""
          }`}
        >
          <span className="op-stepper__marker" aria-hidden="true">
            {isDone ? "✓" : index + 1}
          </span>
          <span className="op-stepper__label">{step.label}</span>
        </li>
      );
    })}
  </ol>
);

export default Stepper;
